// extracted by mini-css-extract-plugin
export default {"wrapper":"OrganizationCommoditiesPage_wrapper__R5JnD"};